<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading" >
    <mapfre-card [singleCard]="false" [additionalClasses]="'request-success fs-16 lh-normal col-2d373d'">
        <section class="text-center mb-4 margin-horizontal mh8">
            <ng-container *ngIf="!isAcmic; else acmicCloseIcon">
                <img src="./assets/img/images/icon-check-circle-mapfre.svg" alt="check circle icon" />
            </ng-container>
            <ng-template #acmicCloseIcon>
                <img src="./assets/img/images/icon-check-circle-acmic.svg" alt="check circle icon" />
            </ng-template>
            <ng-container *ngIf="requestQuestion; else reissueMyRefund">
                <h5 class="delpmtsuccessheader mt-3">{{ submitRequestType | translate}}</h5>
            </ng-container>
            <ng-template #reissueMyRefund>
                <h5 class="delpmtsuccessheader mt-3 lh-normal">{{"THANK_SUBMITTING" | translate}} {{ submitRequestType | translate}}</h5>
            </ng-template>

            <div *ngIf="requestType && requestType === 'cancellations'" class="mt-4">
                <p>{{ 'REPLY_WITHIN_TWO_FOUR_CANCEL_REQUEST' | translate }}</p>
                <p></p>
                <p>
                    {{ 'NOT_RECEIVE_CONFIRM_CALL_US' | translate }}
                    <a class="see-dec nobr" href="tel:18556273737">855-627-3737</a>.
                </p>
            </div>

            <div *ngIf="requestType && requestType === 'refund'" class="mt-4">
                <div class="blue-msg-box mb-4" *ngIf="!requestQuestion">
                    <div class="icon-section">
                        <img src="./assets/img/images/blue-info-icon.svg" class="blue-info-icon" alt="info icon">
                    </div>
                    <div class="msg-section">
                        {{ info | translate}}
                    </div>
                </div>

                <p>{{ 'REPLY_WITHIN_TWO_DAYS' | translate }}</p>
            </div>
            
            <div class="mt-4 lh-24">{{ 'COPY_TO_YOUR_EMAIL' | translate }}</div>
            <div class="lh-24"><strong>{{ emailAddress }}</strong></div>
        </section>

        <div class="row text-center">
            <div class="col billing-request-btn">                  
                <mapfre-button 
                [additionalClasses]="'basic primary large-btn waves-effect'"
                [iconClasses]="'align-middle'"
                (click)="onClickBack()"> {{ 'CLOSE' | translate }}
                </mapfre-button>
            </div>                
        </div>
    </mapfre-card>
</ng-container>